module.exports = __webpack_public_path__ + "img/impactoF1.0ec53d07.png";